import { FunctionComponent } from 'react';

import Box from '../../Layout/Box/Box';
import Step from './Step/Step';
import SubTitle from '../../Text/SubTitle/SubTitle';

import styles from './Stepper.module.scss';
import { useDatadogLog } from '../../Input/logging';

export type StepperProps = {
  steps: {
    label: string;
    content: React.ReactNode;
    percentageComplete: number;
    hasError?: boolean;
  }[];
  currentStep: number;
  isComplete: boolean;
  onStepClick: (idx: number) => void;
};

type FC = FunctionComponent<StepperProps>;

const Stepper: FC = ({ steps, currentStep, isComplete, onStepClick }: StepperProps) => {
  const step = steps[currentStep];
  const log = useDatadogLog();

  const handleStepClick = (stepNumber: number) => {
    log({
      message: `Step ${stepNumber} clicked`,
      payload: { name: step.label, value: stepNumber },
      actionType: 'Button',
    });
    onStepClick(stepNumber - 1);
  };

  return (
    <div className={styles.container}>
      {steps.length > 2 && (
        <Box jc="sb" mb="lg">
          {steps.map(({ label, hasError }, idx) => (
            <Step
              key={`stepper-${label}-${idx}`}
              number={idx + 1}
              label={label}
              isActive={currentStep === idx}
              hasError={hasError}
              percentageComplete={isComplete ? 100 : steps[idx].percentageComplete}
              isLast={steps.length - 1 === idx}
              onClick={handleStepClick}
            />
          ))}
        </Box>
      )}
      <Box ai="center" jc="sb" mb="lg">
        <SubTitle subTitle={step.label} />
      </Box>
      {step.content}
    </div>
  );
};

export default Stepper;
